import API from '@/services/api'

// Actions
export const FETCH_OBJECTS = 'fetchObjects'
export const FETCH_OBJECT = 'fetchObject'
export const CREATE_OBJECT = 'createObject'
export const UPDATE_OBJECT = 'updateObject'
export const UPDATE_OBJECT_SILENT = 'updateObjectSilent'
export const DELETE_OBJECT = 'deleteObject'
export const IMPORT_PROJECTS = 'importProjects'
export const GENERATE_OBJECT_REPORT = 'generateObjectReport'

// Mutations
export const STORE_SET_OBJECTS = 'storeSetObjects'
export const STORE_SET_COUNTERS = 'storeSetCounters'
export const STORE_ADD_OBJECT = 'storeAddObject'
export const STORE_UPDATE_OBJECT = 'storeUpdateObject'
export const STORE_DELETE_OBJECT = 'storeDeleteObject'

// Only the latest request may update the list, so slow responses for older search terms are ignored
let latestObjectsRequest = 0

const state = {
	counters: [],
	objects: {
		data: [],
		meta: {
			total: 0,
			per_page: 15,
			from: 1,
			to: 0,
			current_page: 1,
		},
	},
}

const getters = {
	objects (state) {
		return state.objects
	},
	counters (state) {
		return state.counters
	},
}

const actions = {
	[FETCH_OBJECTS] (context, options) {
		const request = ++latestObjectsRequest
		let query = 'objects/' + options.project + '?page=' + options.page

		if (options.search) {
			query += '&search=' + encodeURIComponent(options.search)
		}

		return new Promise((resolve, reject) => {
			API.query(query).then((response) => {
				if (request === latestObjectsRequest) {
					context.commit(STORE_SET_OBJECTS, response.data)
					context.commit(STORE_SET_COUNTERS, response.data.data.counters)
				}
				resolve(response.data)
			}).catch((response) => {
				reject(response)
			})
		})
	},
	[FETCH_OBJECT] (context, object) {
		return new Promise((resolve, reject) => {
			API.query('objects/' + object.project + '/' + object.object).then((response) => {
				resolve(response.data)
			}).catch((response) => {
				reject(response)
			})
		})
	},
	[CREATE_OBJECT] (context, object) {
		return new Promise((resolve, reject) => {
			API.post('objects/' + object.project, object.data).then((response) => {
				context.commit(STORE_ADD_OBJECT, response.data)
				resolve(response.data)
			}).catch(({ response }) => {
				reject(response.data)
			})
		})
	},
	[GENERATE_OBJECT_REPORT] (context, object) {
		return new Promise((resolve, reject) => {
			API.post('objects/' + object.id + '/report', object.data).then((response) => {
				resolve(response.data)
			}).catch(({ response }) => {
				reject(response.data)
			})
		})
	},
	[UPDATE_OBJECT] (context, object) {
		return new Promise((resolve, reject) => {
			API.update('objects/' + object.projectID, object.id, object.changes).then((response) => {
				context.commit(STORE_UPDATE_OBJECT, response.data)
				resolve(response.data)
			}).catch((response) => {
				reject(response)
			})
		})
	},
	[UPDATE_OBJECT_SILENT] (context, object) {
		return new Promise((resolve, reject) => {
			API.update('objects/' + object.projectID, object.id, object.changes).then((response) => {
				resolve(response.data)
			}).catch((response) => {
				reject(response)
			})
		})
	},
	[DELETE_OBJECT] (context, object) {
		return new Promise((resolve, reject) => {
			API.delete('objects/' + object.id).then((response) => {
				context.commit(STORE_DELETE_OBJECT, object)
				resolve(response.data)
			}).catch((response) => {
				reject(response)
			})
		})
	},
	[IMPORT_PROJECTS] (context, object) {
		return new Promise((resolve, reject) => {
			API.post('objects/' + object.project + '/import', object.data, {
				headers: {
					'Content-Type': 'multipart/form-data',
				},
			}).then((response) => {
				resolve(response)
			}).catch((response) => {
				reject(response)
			})
		})
	},
}

const mutations = {
	[STORE_SET_OBJECTS] (state, objects) {
		state.objects = objects
	},
	[STORE_SET_COUNTERS] (state, counters) {
		state.counters = counters
	},
	[STORE_ADD_OBJECT] (state, object) {
		state.objects.data.data.unshift(object)
	},
	[STORE_UPDATE_OBJECT] (state, object) {
		let objects = []

		state.objects.data.data.map((mapObject) => {
			if (mapObject.id === object.id) {
				mapObject = object
			}

			objects.push(mapObject)
		})

		state.objects.data.data = objects
	},
	[STORE_DELETE_OBJECT] (state, object) {
		state.objects.data.data.splice(state.objects.data.data.indexOf(object), 1)
	},
}

export default { state, getters, actions, mutations }